import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Send, AlertTriangle } from 'lucide-react';
import { toast } from 'react-toastify';
import './UrgentNotificationModal.css';

const API_URL = import.meta.env.VITE_API_URL;
const getToken = () => localStorage.getItem('token');

const UrgentNotificationModal = ({ onClose }) => {
    const [adminsMods, setAdminsMods] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [titre, setTitre] = useState('');
    const [message, setMessage] = useState('');
    const [lien, setLien] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await axios.get(`${API_URL}/users`, {
                    headers: { Authorization: `Bearer ${getToken()}` }
                });
                if (res.data) {
                    const filtered = res.data.filter(u => ['admin', 'moderateur'].includes(u.typeUser));
                    setAdminsMods(filtered);
                }
            } catch (err) {
                console.error("Erreur chargement utilisateurs:", err);
            }
        };
        fetchUsers();
    }, []);

    const handleSelectUser = (id) => {
        setSelectedUsers(prev =>
            prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
        );
    };

    const selectAll = () => {
        if (selectedUsers.length === adminsMods.length) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(adminsMods.map(u => u._id));
        }
    };

    const handleSend = async (e) => {
        e.preventDefault();
        if (selectedUsers.length === 0) {
            return toast.error("Veuillez sélectionner au moins un destinataire.");
        }
        if (!message.trim()) {
            return toast.error("Le message est obligatoire.");
        }

        setLoading(true);
        try {
            const res = await axios.post(`${API_URL}/notifications/urgent`, {
                destinataires: selectedUsers,
                titre: titre.trim(),
                message: message.trim(),
                lien: lien.trim()
            }, {
                headers: { Authorization: `Bearer ${getToken()}` }
            });

            if (res.data.success) {
                toast.success("Notification urgente envoyée !");
                onClose();
            }
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || "Erreur lors de l'envoi.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="unm-overlay">
            <div className="unm-modal">
                <div className="unm-header">
                    <div className="unm-title">
                        <AlertTriangle size={20} color="#ef4444" />
                        <h2>Nouvelle Alerte Urgente</h2>
                    </div>
                    <button className="unm-close" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <form className="unm-body" onSubmit={handleSend}>
                    <div className="unm-form-group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label>Destinataires (Admins / Modérateurs) *</label>
                            <button type="button" className="unm-select-all" onClick={selectAll}>
                                {selectedUsers.length === adminsMods.length ? 'Tout désélectionner' : 'Sélectionner tout'}
                            </button>
                        </div>
                        <div className="unm-users-list">
                            {adminsMods.map(user => (
                                <label key={user._id} className="unm-user-item">
                                    <input
                                        type="checkbox"
                                        checked={selectedUsers.includes(user._id)}
                                        onChange={() => handleSelectUser(user._id)}
                                    />
                                    <span>{user.prenom} {user.nom} <small className="unm-user-type">({user.typeUser})</small></span>
                                </label>
                            ))}
                            {adminsMods.length === 0 && <div style={{ fontSize: '12px', color: '#64748b' }}>Chargement...</div>}
                        </div>
                    </div>

                    <div className="unm-form-group">
                        <label>Titre de l'alerte</label>
                        <input
                            type="text"
                            className="unm-input"
                            placeholder="Ex: Réunion de crise, Problème serveur..."
                            value={titre}
                            onChange={e => setTitre(e.target.value)}
                        />
                    </div>

                    <div className="unm-form-group">
                        <label>Message *</label>
                        <textarea
                            className="unm-textarea"
                            rows="4"
                            placeholder="Détails de l'alerte urgente..."
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            required
                        />
                    </div>

                    <div className="unm-form-group">
                        <label>Lien (Optionnel)</label>
                        <input
                            type="text"
                            className="unm-input"
                            placeholder="URL ou chemin interne (ex: /bo/clients/123)"
                            value={lien}
                            onChange={e => setLien(e.target.value)}
                        />
                    </div>

                    <div className="unm-footer">
                        <button type="button" className="unm-btn-cancel" onClick={onClose}>Annuler</button>
                        <button type="submit" className="unm-btn-send" disabled={loading}>
                            <Send size={16} />
                            {loading ? 'Envoi...' : 'Envoyer l\'alerte'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UrgentNotificationModal;
